/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * How the client authenticates upstream. Only shared types are offered.
 */
export const AuthClientChoiceClientType = {
  ServiceAccount: "service_account",
  StaticCredential: "static_credential",
  PassThrough: "pass_through",
} as const;
/**
 * How the client authenticates upstream. Only shared types are offered.
 */
export type AuthClientChoiceClientType = OpenEnum<
  typeof AuthClientChoiceClientType
>;

/**
 * A shared upstream credential a caller can choose for a credential of their own, such as an agent key.
 */
export type AuthClientChoice = {
  /**
   * How the client authenticates upstream. Only shared types are offered.
   */
  clientType: AuthClientChoiceClientType;
  /**
   * The auth client id.
   */
  id: string;
  /**
   * The client's name.
   */
  name: string;
};

/** @internal */
export const AuthClientChoiceClientType$inboundSchema: z.ZodMiniType<
  AuthClientChoiceClientType,
  unknown
> = openEnums.inboundSchema(AuthClientChoiceClientType);

/** @internal */
export const AuthClientChoice$inboundSchema: z.ZodMiniType<
  AuthClientChoice,
  unknown
> = z.pipe(
  z.object({
    client_type: AuthClientChoiceClientType$inboundSchema,
    id: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_type": "clientType",
    });
  }),
);

export function authClientChoiceFromJSON(
  jsonString: string,
): SafeParseResult<AuthClientChoice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthClientChoice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthClientChoice' from JSON`,
  );
}
